import React, { createContext, FC, ReactElement, useContext } from 'react'
import { TFrameEvent, TParentFrameContext } from './types'

const publishEvent = (event: TFrameEvent) => {
    setTimeout(() => {
        window.parent.postMessage(event, '*')
    }, 0)
}

const ParentFrameContext = createContext<TParentFrameContext>(publishEvent)

type Props = {
    children: ReactElement
}

const ParentFrameProvider: FC<Props> = ({ children }) => {
    return (
        <ParentFrameContext.Provider value={publishEvent}>{children}</ParentFrameContext.Provider>
    )
}

const usePublishFrameEvent = (): TParentFrameContext => {
    const context = useContext(ParentFrameContext)
    if (context === undefined) {
        throw new Error('usePublishFrameEvent must be used within a ParentFrameContext')
    }
    return context
}

export { ParentFrameProvider, usePublishFrameEvent }
